import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const colours = {
    background: {
        success: tokens.colorStatusSuccessBackground1,
        warning: tokens.colorPaletteMarigoldBackground1,
        error: tokens.colorStatusDangerBackground1,
    },
    foreground: {
        success: tokens.colorStatusSuccessForeground1,
        warning: tokens.colorPaletteMarigoldForeground1,
        error: tokens.colorStatusDangerForeground1,
        neutral: tokens.colorNeutralForeground4,
    },
} as const;

export const useFeatureTileStyles = makeStyles({
    root: {
        padding: '16px',
    },
    featureIcon: {
        width: '48px',
        height: '48px',
        padding: '8px',
        borderRadius: tokens.borderRadiusLarge,
        backgroundColor: tokens.colorBrandBackground2,

        '& > svg': {
            width: '100%',
            height: '100%',
        },
    },
    description: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },
    statusItem: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
    },
    statusIndicator: {
        width: '1em',
        height: '1em',
        borderRadius: tokens.borderRadiusCircular,

        '&.Unknown': {
            backgroundColor: colours.foreground.neutral,
        },
        '&.Ok': {
            backgroundColor: colours.foreground.success,
        },
        '&.Warning': {
            backgroundColor: colours.foreground.warning,
        },
        '&.Error': {
            backgroundColor: colours.foreground.error,
        },
    },
    featureItems: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
    },
    featureStatus: {
        border: `${tokens.strokeWidthThin} solid`,
        borderRadius: tokens.borderRadiusLarge,

        '&.Ok': {
            backgroundColor: colours.background.success,
            color: colours.foreground.success,
            ...shorthands.borderColor(colours.foreground.success),
        },
        '&.Warning': {
            backgroundColor: colours.background.warning,
            color: colours.foreground.warning,
            ...shorthands.borderColor(colours.foreground.warning),
        },
        '&.Error': {
            backgroundColor: colours.background.error,
            color: colours.foreground.error,
            ...shorthands.borderColor(colours.foreground.error),
        },
    },
    featureStatusLabel: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',

        '& svg': {
            fontSize: '2rem',
        },

        '& svg.Unhealthy': {
            color: colours.foreground.error,
        },
        '& svg.Unknown': {
            color: colours.foreground.warning,
        },
    },
    services: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        marginTop: '8px',
    },
});
